export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-iphone-3.f9ac3385.svg";